var attribution = require("./attribution");

// Banner cookie (markup in app-shell.blade.php), conforme alle Linee guida del Garante del 10/06/2021:
// nessuna casella pre-selezionata, "Rifiuta" con lo stesso peso di "Accetta", la X chiude rifiutando,
// scelta per categoria. Un rifiuto non viene richiesto prima di 6 mesi.
//
// localStorage:
//  - cookieconsent_analytics "true"/"false": Statistiche (Google Analytics)
//  - cookieconsent_ads       "true"/"false": Pubblicità (Google Ads, Facebook, attribuzione campagne)
//  - cookieconsent_version / cookieconsent_ts: versione del banner e data della scelta
// Le stesse chiavi sono lette da app-shell (Consent Mode) e da attribution.js.
// CONSENT_VERSION invalida le scelte dei banner precedenti (casella pre-selezionata o categoria unica).
var CONSENT_VERSION = "3";
var REASK_AFTER_REJECT_MS = 182 * 24 * 60 * 60 * 1000;

function read(key) {
	try {
		return localStorage.getItem(key);
	} catch (e) {
		return null;
	}
}

function write(key, value) {
	try {
		localStorage.setItem(key, value);
	} catch (e) {}
}

function remove(key) {
	try {
		localStorage.removeItem(key);
	} catch (e) {}
}

function current() {
	var valid = read("cookieconsent_version") === CONSENT_VERSION;
	return {
		analytics: valid && read("cookieconsent_analytics") === "true",
		ads: valid && read("cookieconsent_ads") === "true"
	};
}

function needsChoice() {
	if (read("cookieconsent_version") !== CONSENT_VERSION) {
		return true;
	}
	var choice = current();
	if (choice.analytics || choice.ads) {
		return false;
	}
	// Ha rifiutato tutto: si richiede solo dopo 6 mesi
	var ts = parseInt(read("cookieconsent_ts"), 10);
	return !ts || Date.now() - ts > REASK_AFTER_REJECT_MS;
}

function updateGoogleConsent(choice) {
	if (typeof window.gtag !== "function") {
		return;
	}
	var ads = choice.ads ? "granted" : "denied";
	window.gtag("consent", "update", {
		ad_storage: ads,
		ad_user_data: ads,
		ad_personalization: ads,
		analytics_storage: choice.analytics ? "granted" : "denied"
	});
}

function enableThirdParties(choice) {
	if (choice.ads) {
		if (typeof window.idcLoadFacebookSdk === "function") {
			window.idcLoadFacebookSdk();
		}
		attribution.persist();
	}
	if ((choice.analytics || choice.ads) && window.dataLayer) {
		window.dataLayer.push({ event: "cookieConsentGiven" });
	}
}

function saveChoice(choice) {
	var before = current();

	write("cookieconsent_analytics", choice.analytics ? "true" : "false");
	write("cookieconsent_ads", choice.ads ? "true" : "false");
	write("cookieconsent_version", CONSENT_VERSION);
	write("cookieconsent_ts", String(Date.now()));
	remove("cookieconsent"); // chiave del vecchio banner
	updateGoogleConsent(choice);

	if (!choice.ads) {
		remove("idc_attribution");
	}
	// Revoca di qualcosa già concesso: gli script caricati restano in pagina, si riparte puliti
	if ((before.analytics && !choice.analytics) || (before.ads && !choice.ads)) {
		window.location.reload();
		return;
	}
	enableThirdParties(choice);
	closeBanner();
}

function openBanner() {
	var choice = current();
	$("#cookie-analytics").prop("checked", choice.analytics);
	$("#cookie-ads").prop("checked", choice.ads);
	$(".cookie-container").fadeIn();
}

function closeBanner() {
	$(".cookie-container").fadeOut();
	showPreferences(false);
}

function showPreferences(show) {
	$("#cookie-preferences").prop("hidden", !show);
	$(".js-cookie-save").prop("hidden", !show);
	$(".js-cookie-customize").prop("hidden", show).attr("aria-expanded", show ? "true" : "false");
}

$(document).ready(function() {
	if (needsChoice()) {
		openBanner();
	} else {
		enableThirdParties(current());
	}

	$(".js-cookie-accept").on("click", function() {
		saveChoice({ analytics: true, ads: true });
	});

	$(".js-cookie-reject").on("click", function() {
		saveChoice({ analytics: false, ads: false });
	});

	$(".js-cookie-customize").on("click", function() {
		showPreferences(true);
	});

	$(".js-cookie-save").on("click", function() {
		saveChoice({
			analytics: $("#cookie-analytics").is(":checked"),
			ads: $("#cookie-ads").is(":checked")
		});
	});

	$(document).on("click", ".js-cookie-preferences", function(e) {
		e.preventDefault();
		openBanner();
	});
});
